/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as E from "fp-ts/Either";
import * as O from "fp-ts/Option";
import { pipe } from "fp-ts/function";
import { ofType } from "redux-observable";
import { map } from "rxjs/operators";

import {
    DELETE_COOKIE_FAILURE,
    DELETE_COOKIE_REQUEST,
    DELETE_COOKIE_SUCCESS,
    DeleteCookieFailure,
    DeleteCookieSuccess,
    READ_COOKIE_FAILURE,
    READ_COOKIE_REQUEST,
    READ_COOKIE_SUCCESS,
    ReadCookieFailure,
    ReadCookieSuccess,
    SAVE_COOKIE_FAILURE,
    SAVE_COOKIE_REQUEST,
    SAVE_COOKIE_SUCCESS,
    SaveCookieFailure,
    SaveCookieRequest,
    SaveCookieSuccess,
} from "src/state/ducks/auth";
import { deleteCookie, readCookie, saveCookie } from "src/utils/storage";

export const readCookieEpic = (action$: any): ReadCookieFailure | ReadCookieSuccess => {
    return action$.pipe(
        ofType(READ_COOKIE_REQUEST),
        map(() => {
            return pipe(
                readCookie("fsci")(),
                E.fold(
                    () => ({ type: READ_COOKIE_FAILURE }),
                    (cookie) => ({ type: READ_COOKIE_SUCCESS, payload: cookie }),
                ),
            );
        }),
    );
};

export const saveCookieEpic = (action$: any): SaveCookieFailure | SaveCookieSuccess => {
    return action$.pipe(
        ofType(SAVE_COOKIE_REQUEST),
        map((action: SaveCookieRequest) => {
            return pipe(
                saveCookie("fsci", action.payload)(),
                O.fold(
                    () => ({ type: SAVE_COOKIE_FAILURE }),
                    () => ({ type: SAVE_COOKIE_SUCCESS, payload: action.payload }),
                ),
            );
        }),
    );
};

export const deleteCookieEpic = (action$: any): DeleteCookieFailure | DeleteCookieSuccess => {
    return action$.pipe(
        ofType(DELETE_COOKIE_REQUEST),
        map(() => {
            return pipe(
                deleteCookie("fsci")(),
                O.fold(
                    () => ({ type: DELETE_COOKIE_FAILURE }),
                    () => ({ type: DELETE_COOKIE_SUCCESS }),
                ),
            );
        }),
    );
};
